import { render, staticRenderFns } from "./LookupDomain.vue?vue&type=template&id=466d1cae&scoped=true&"
import script from "./LookupDomain.vue?vue&type=script&lang=ts&"
export * from "./LookupDomain.vue?vue&type=script&lang=ts&"
import style0 from "./LookupDomain.vue?vue&type=style&index=0&id=466d1cae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d1cae",
  null
  
)

export default component.exports